import type { FeedRequest } from "../api";

const DEFAULT_FEED_LIMIT = 20;

export const feedQueryKeys = {
  all: ["feed"] as const,
  list: (request: FeedRequest) => {
    const subject =
      request.scope === "community"
        ? request.communityId
        : request.scope === "user"
          ? request.userId
          : null;
    return [
      ...feedQueryKeys.all,
      "list",
      request.scope,
      subject,
      request.limit ?? DEFAULT_FEED_LIMIT,
    ] as const;
  },
};

export const homeFeedQueryKeys = {
  all: ["home-feed"] as const,
  list: (request: { limit?: number } = {}) =>
    ["home-feed", "list", request.limit ?? DEFAULT_FEED_LIMIT] as const,
};
